var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M30.6,41.688a1.5,1.5,0,0,1-1.5-1.5V12.1a1.5,1.5,0,0,1,3,0V40.188A1.5,1.5,0,0,1,30.6,41.688Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M30.6,41.688a1.5,1.5,0,0,1-1.061-.439L20.752,32.46a1.5,1.5,0,0,1,2.121-2.121l8.788,8.788a1.5,1.5,0,0,1-1.06,2.561Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M30.6,41.688a1.5,1.5,0,0,1-1.061-2.561l8.788-8.788a1.5,1.5,0,0,1,2.121,2.121l-8.788,8.789A1.5,1.5,0,0,1,30.6,41.688Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M35.258,53.4H12.742a1.5,1.5,0,1,1,0-3H35.258a14.517,14.517,0,0,0,14.5-14.5V19.2a1.5,1.5,0,1,1,3,0V35.9A17.52,17.52,0,0,1,35.258,53.4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.c4c40cc93bcd3a7b20d374406f235aee.svg";
export { ForwardRef as ReactComponent };